import {Ability} from '~/lib/ability';

export class BusinessIncentivesAbility extends Ability {
    canCreate = () => this.isAdmin();
    canEdit = () => this.isAdmin();
    canDelete = () => this.isAdmin();
}
